import { AccessDenied } from './access-denied';

import type { ReactNode } from 'react';

import { useAuthStore } from '@/stores/auth-store';

const ALLOWED_ROLES = new Set(['hr_admin', 'org_admin']);

export function RoleGate({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);

  if (!user || !ALLOWED_ROLES.has(user.role)) {
    return <AccessDenied />;
  }

  return <>{children}</>;
}
